// test820
(820 && 0);
